import { lazy } from 'react';
import { IRouter } from '@/components/constants/interface';

const routerConfig: IRouter[] = [
  {
    path: '/',
    name: '首页',
    component: lazy(() => import('@/layouts')),
    children: [
      {
        path: '',
        name: '首页',
        component: lazy(() => import('@/pages/home')),
      },
      {
        path: '/customer',
        name: '客户',
        children: [
          {
            path: 'list',
            name: '客户信息',
            component: lazy(() => import('@/pages/customer')),
          },
        ],
      },
      {
        path: '/shop',
        name: '店铺',
        children: [
          {
            path: 'list',
            name: '店铺列表',
            component: lazy(() => import('@/pages/shop')),
          },
        ],
      },
    ],
  },
  {
    path: 'login',
    name: '登录',
    component: lazy(() => import('@/pages/login')),
  },
];

export default routerConfig;
